import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

export function DemoBadge({ compact = false }: { compact?: boolean }) {
  return <span className="inline-flex items-center gap-1 rounded-full border border-amber-300/25 bg-amber-300/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[.16em] text-amber-200"><Sparkles size={11} />{compact ? 'Demo' : 'Demo data — not live odds'}</span>;
}

export function SectionHeading({ eyebrow, title, description, action, headingLevel = 2 }: { eyebrow?: string; title: string; description?: string; action?: { label: string; to: string }; headingLevel?: 1 | 2 }) {
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  return <div className="mb-5 flex items-end justify-between gap-5">
    <div>
      {eyebrow && <div className="mb-2 text-xs font-bold uppercase tracking-[.2em] text-lime">{eyebrow}</div>}
      <Heading className="display text-2xl font-extrabold sm:text-3xl">{title}</Heading>
      {description && <p className="mt-2 max-w-2xl text-sm leading-6 text-muted">{description}</p>}
    </div>
    {action && <Link className="hidden shrink-0 items-center gap-2 text-sm font-bold text-lime sm:flex" to={action.to}>{action.label}<ArrowRight size={16} /></Link>}
  </div>;
}

export function PrimaryLink({ to, children, className = '' }: { to: string; children: ReactNode; className?: string }) {
  return <Link to={to} className={`focus-ring inline-flex items-center justify-center gap-2 rounded-xl bg-lime px-4 py-3 text-sm font-extrabold transition hover:brightness-105 ${className}`}>{children}</Link>;
}

export function SecondaryLink({ to, children, className = '' }: { to: string; children: ReactNode; className?: string }) {
  return <Link to={to} className={`focus-ring inline-flex items-center justify-center gap-2 rounded-xl border border-soft bg-white/[.035] px-4 py-3 text-sm font-bold transition hover:bg-white/[.07] ${className}`}>{children}</Link>;
}

export function Button({ className = '', children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={`focus-ring inline-flex items-center justify-center gap-2 rounded-xl bg-lime px-4 py-3 text-sm font-extrabold transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props}>{children}</button>;
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return <div className="surface rounded-2xl p-10 text-center"><h3 className="display text-xl font-bold">{title}</h3><p className="mx-auto mt-2 max-w-lg text-sm text-muted">{description}</p></div>;
}
